import {toChildArray, cloneElement} from 'preact';

// Only the local editor supplies its own title bar; production uses App Bridge.
export default function Page({children, ...props}) {
  if (typeof __STANDALONE__ === 'undefined' || !__STANDALONE__) return <s-page {...props}>{children}</s-page>;
  const content = toChildArray(children);
  const slots = ['primary-action', 'secondary-actions', 'breadcrumb-actions'];
  const breadcrumbs = content.filter(child => child?.props?.slot === 'breadcrumb-actions');
  const actions = content.filter(child => ['primary-action', 'secondary-actions'].includes(child?.props?.slot));
  return <>
    {props.heading && <header class="local-page-header"><a href="/">App</a><span aria-hidden="true">›</span>
      {breadcrumbs.map(child => <>{cloneElement(child, {slot: undefined})}<span aria-hidden="true">›</span></>)}
      <h1>{props.heading}</h1>
      {actions.map(child => cloneElement(child, {slot: undefined}))}</header>}
    <s-page {...props}>{content.filter(child => !slots.includes(child?.props?.slot))}</s-page>
  </>;
}
